export const css = {
	root: '_20MUpt0L',
	header: 'YOyD6iI-',
	title: '_6lByAlEe',
	content: 'iC3nAtF0',
	hero: '_7X41gWG0',
	center: 'ODtAnPz7',
	quizButton: 'R6KrnLpM',
	label: 'yvi3exb3',
	badge: 'XLehyVUt',
	trailing: '_7cUXzM2c',
	progressContainer: 'f7OZ0Uya',
	panels: '_6JVL5SL-',
	panelColumn: 'mWu0S-3U',
	panel: 'DatpuWzW',
	actionContainer: '_6qOJjJuB',
	actionButtons: 'yDMncjK-',
	actionButton: 'mrd0Lg3i',
	innerContainer: 'Kpqx86vP',
	readingProgress: '_0MP8ARhi',
	scoreChart: 'e9c5fGlR',
	scoreContainer: 'yexFZycI',
	small: 'RJ3bzwZ2',
	bestScore: 'y1Tu6F02',
	toast: '-F0M-GOj',
	noScore: 'DYEc0FGn',
	lowScore: '_0Q9nOYBm',
	midScore: 'AaYoTUQx',
	highScore: 'EyIYnN5V',
	legend: 'jzxL7b-o',
	legendSelect: '_7aOch-ui',
	' _key': 'mc-widgets/progress-view'
};

export default css;
